import React from 'react';

const OpenEyeIcon = () => (
    <svg className="svg-icon open-eye-icon" width="16px" height="10px" viewBox="12 15 16 10"
        xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <g className="theme-path" fillRule="evenodd" transform="translate(0.000000, 0.000000)">
            <path d="M12,22 C12.495935,18.0536884 15.8885734,15 20,15 C24.1114266,15 27.504065,18.0536884 28,
            22 L25.963177,22 C25.4833869,19.1622867 22.9961769,17 20,17 C17.0038231,17 14.5166131,19.1622867 14.036823,
            22 L12,22 Z M20,25 C18.3302272,25 16.9766089,23.6568542 16.9766089,22 C16.9766089,20.3431458 18.3302272,
            19 20,19 C21.6697728,19 23.0233911,20.3431458 23.0233911,22 C23.0233911,23.6568542 21.6697728,25 20,25 Z">
            </path>
        </g>
    </svg>
);

export default OpenEyeIcon;
